import { useMemo } from 'react';
import type { PageMetaProps } from '@core/interfaces';

interface UsePageMetaOptions {
  fallbackTitle?: string;
  fallbackSubtitle?: string;
}

export function usePageMeta(
  props: PageMetaProps,
  options?: UsePageMetaOptions
): { title: string; subtitle?: string } {
  return useMemo(() => {
    if ('navItems' in props) {
      const navItem = props.navItems
        ?.flatMap((item) => [item, ...(item.children ?? [])])
        .find((item) => item.path === props.path);
      return {
        title: navItem?.title ?? options?.fallbackTitle ?? '',
        subtitle: navItem?.subtitle ?? options?.fallbackSubtitle,
      };
    }

    return {
      title: props.title ?? options?.fallbackTitle ?? '',
      subtitle: props.subtitle ?? options?.fallbackSubtitle,
    };
  }, [props, options?.fallbackTitle, options?.fallbackSubtitle]);
}
